import { date, showAlert } from '../../../lib/helpers';
import { editedItem, headers, search } from './attributes';
import { dataListPaymentType, dataListSettlementStatus, dataListTrxReportStatus, dataListTrxType, dataQrMethod, dataQrType, promoCodeFilter, sof, transactionQrMethod } from '../../../store/params';

export default {
  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonDots: true,
      buttonSwitchCh: true,
      buttonDotsExt: [
        {
          link: 'exportExcelParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
      ],
    },
    switchCh: true,
    isFirstLoad: true,
    rangeDateDialog: false,
    options: {},
    show: false,
    dialog: false,
    expanded: [],
    headers,
    filter: {
      trx_datetime: [],
    },
    search,
    editedItem,
    selectedRow: '',
    searchAcquirer: '',
    searchIssuer: '',
    listTrxReportStatus: dataListTrxReportStatus,
    listPaymentType: dataListPaymentType,
    listTrxType: dataListTrxType,
    qrMethod: dataQrMethod,
    qrType: dataQrType,
    dateFormatted: '',
    dateMenu: false,
    listSettlementStatus: dataListSettlementStatus,
    listSof: sof,
    filterValue: { trx_datetime: [], ac_id: '', payment_type: '', rrn: '', mid: '', bill_num: '', status: '', promo_code: '', qr_method: '' },
    submittedFilter: { trx_datetime: [], ac_id: '', payment_type: '', rrn: '', mid: '', bill_num: '', status: '', promo_code: '', qr_method: '' },
    searchAggregator: '',
    searchMerchant: '',
    loadingMerchant: false,
    loadingAggregator: false,
    acId: null,
    mId: null,
  }),

  computed: {

    filterConfig(){
      const base = [
        { key: 'trx_datetime', type: 'daterange', required: true, props: { label: 'Transaction Date', includeToday: true, limitRangeTo30Days: true } },
        {
          key: 'ac_id',
          type: 'autocomplete',
          props: {
            label: 'Aggregator Name',
            items: this.aggregatorList,
            loading: this.loadingAggregator,
            itemText: 'merchant_name',
            itemValue: 'ac_id',
            search: this.searchAggregator,
          }
        },
        { key: 'payment_type', type: 'select', props: { label: 'Payment Type', items: dataListPaymentType } },
        { key: 'rrn', type: 'textfield', props: { label: 'Reff ID' } },
      ];

      if (this.searchAggregator || (this.filterValue && this.filterValue.ac_id)) {
        base.push({
          key: 'mid',
          type: 'autocomplete',
          props: {
            label: 'MID',
            items: this.merchantList,
            loading: this.loadingMerchant,
            itemText: 'mid',
            itemValue: 'mid',
            search: this.searchMerchant,
            scopedSlots: {
              item: (props) => `${props.item.mid} - ${props.item.merchant_name}`
            }
          }
        });
      }

      const isSwitcherDisabled = this.filterValue.payment_type === 'on us';

      base.push(
        { key: 'bill_num', type: 'textfield', props: { label: 'Bill Number' } },
        { key: 'status', type: 'select', props: { label: 'Status', items: dataListTrxReportStatus } },
        { key: 'qr_method', type: 'select', props: { label: 'QR Method', items: transactionQrMethod } },
        { key: 'promo_code', type: 'select', props: { label: 'Switcher', items: promoCodeFilter, disabled: isSwitcherDisabled } },
      );

      return base;
    },
    aggregatorList() {
      return this.$store.state.report.aggregatorList;
    },
    merchantList() {
      return this.$store.state.report.merchantList;
    },
    allData() {
      return this.$store.state.report.inputerAggregatorTransaction.allData;
    },
    detailData() {
      return this.$store.state.report.inputerAggregatorTransaction.item;
    },
    allCategory() {
      return this.$store.state.report.inputerAggregatorTransaction.allCategory;
    },
    totalData() {
      return this.$store.state.report.inputerAggregatorTransaction.totalData;
    },
    totalPage() {
      return this.$store.state.report.inputerAggregatorTransaction.totalPage;
    },
    loading() {
      return this.$store.state.report.inputerAggregatorTransaction.loading;
    },
    flashError: {
      get() {
        return this.$store.state.report.inputerAggregatorTransaction.flashError;
      },
      set() {
        this.$store.commit(
          'report/inputerAggregatorTransaction/setFlashErrorMessage',
          ''
        );
      },
    },
    flashErrorMessage() {
      return this.$store.state.report.inputerAggregatorTransaction.flashErrorMessage;
    },
    /**
     * @returns menentukan apa env filter ch true
     */
    checkFilterCh() {
      return JSON.parse(process.env.VUE_APP_FILTER_CH);
    },
    /**
     * @returns jika env VUE_APP_FILTER_CH true, makan akan sesuai toggle. namun jika tidak, untuk default apakah ch atau bukan dengan env VUE_APP_DB_CH
     */
    checkEnvCh() {
      let filterCh = process.env.VUE_APP_DB_CH;

      if (this.checkFilterCh) {
        const filterOn = process.env.VUE_APP_FILTER_DEFAULT;
        const filterOff = filterOn === 'ch' ? 'sql' : 'ch';
        filterCh = this.switchCh ? filterOn : filterOff;
      }

      return filterCh;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('report/inputerAggregatorTransaction/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
    switchCh: {
      handler() {
        this.clearSearch();
      },
    },
    searchAggregator(val) {
      if (val && val.length >= 3) {
        this.acId = val;
        this.getAggregator();
      } else {
        this.acId = '';
        this.$store.commit('report/clearAggregator');
      }
    },
    searchMerchant(val) {
      if (val && val.length >= 3) {
        this.mId = val;
        this.getMerchant();
      } else {
        this.mId = '';
        this.$store.commit('report/clearMerchant');
      }
    },
    'filterValue.payment_type': {
      handler(newVal) {
        if (newVal === 'on us' && this.filterValue.promo_code) {
          this.$set(this.filterValue, 'promo_code', '');
          this.$set(this.search, 'promo_code', '');
        }
      }
    },
    'filterValue.promo_code': {
      handler(newVal) {
        if (newVal && newVal !== '' && this.filterValue.payment_type !== 'off us') {
          this.$set(this.filterValue, 'payment_type', 'off us');
          this.$set(this.search, 'payment_type', 'off us');
        }
      }
    },
    'filterValue.ac_id': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$store.commit('report/clearMerchant');
          this.filterValue.mid = '';
        
          if (newVal) {
            this.getMerchant();
          }
        }
      }
    },
  },

  methods: {
    handleFilterSearchInput(payload) {
      const { key, value } = payload || {};
      if (key === 'ac_id') {
        this.searchAggregator = value;
      }
      else if (key === 'mid') {
        this.searchMerchant = value;
      }
    },
    handleFilterValueChange(payload) {
      const { key, value } = payload || {};
      
      if (key === 'ac_id') {
        this.$set(this.filterValue, 'ac_id', value);
        this.$set(this.filterValue, 'mid', '');
        this.$store.commit('report/clearMerchant');
        if (value) {
          this.getMerchant();
        }
      } else if (key === 'mid') {
        this.$set(this.filterValue, 'mid', value);
      } else if (key === 'payment_type') {
        this.$set(this.filterValue, 'payment_type', value);
        this.$set(this.search, 'payment_type', value);
        
        if (value === 'on us') {
          this.$set(this.filterValue, 'promo_code', '');
          this.$set(this.search, 'promo_code', '');
        }
      } else if (key === 'promo_code') {
        this.$set(this.filterValue, 'promo_code', value);
        this.$set(this.search, 'promo_code', value);
        
        if (value && value !== '') {
          this.$set(this.filterValue, 'payment_type', 'off us');
          this.$set(this.search, 'payment_type', 'off us');
        }
      } else {
        this.$set(this.filterValue, key, value);
        this.$set(this.search, key, value);
      }
    },
    getMerchant() {
      this.loadingMerchant = true;
      this.$store.commit('report/setFlashErrorMessage', '');
      const selectedAcId = this.filterValue.ac_id;
  
      this.$store
        .dispatch('report/getMerchant', {
          date,
          sortBy: 'ID',
          search: { ac_id: selectedAcId, mid: this.mId },
          source: 'aggregator',
        })
        .then(() => {
          this.loadingMerchant = false;
        });
    },
    getAggregator() {
      this.loadingAggregator = true;
      this.$store.commit('report/setFlashErrorMessage', '');
      this.$store
        .dispatch('report/getAggregator', {
          date,
          sortBy: 'ID',
          search: { name: this.acId },
        })
        .then(() => {
          this.loadingAggregator = false;
        });
    },
    getTooltipMethod(item) {
      const descriptions = {
        mpm: 'Merchant Presented Mode',
        cpm: 'Customer Presented Mode',
        qristap: 'QRIS NFC',
        'qris tap - single': 'Single Tap Mode',
        'qris tap - tap out': 'Tap Out Finalization Mode',
        'qris tap - tap out without completion': 'Tap Out Without Completion Mode'
      };
      const jenis = item.qr_method?.toLowerCase() || '';
      return descriptions[jenis] || '';
    },
    getTooltipPayement(item) {
      const descriptions = {
        'on us': 'Transaksi pembayaran dalam jaringan BNI',
        'off us': 'Transaksi pembayaran diluar jaringan BNI'
      };

      const jenis = item.payment_type?.toLowerCase() || '';
      return descriptions[jenis] || '';
    },
    updateSearchValues(newSearch) {
      let paymentType = newSearch.payment_type || '';
      let promoCode = newSearch.promo_code || '';
      
      if (paymentType === 'on us') {
        promoCode = '';
      } else if (promoCode && promoCode !== '') {
        paymentType = 'off us';
      }

      const fields = ['trx_datetime', 'ac_id', 'rrn', 'mid', 'bill_num', 'status', 'qr_method'];
      fields.forEach(field => {
        const value = field === 'trx_datetime' ? (newSearch[field] || []) : (newSearch[field] || '');
        this.$set(this.search, field, value);
        this.$set(this.filterValue, field, value);
      });

      this.$set(this.search, 'payment_type', paymentType);
      this.$set(this.search, 'promo_code', promoCode);
      this.$set(this.filterValue, 'payment_type', paymentType);
      this.$set(this.filterValue, 'promo_code', promoCode);
    },
    updateSearch(newSearch) {
      this.updateSearchValues(newSearch);
      this.submittedFilter = JSON.parse(JSON.stringify(this.filterValue));
      this.options.page = 1;
      this.getData(); 
    },
    showType(newSearch) {
      this.updateSearchValues(newSearch);
      this.submittedFilter = JSON.parse(JSON.stringify(this.filterValue));
      this.options.page = 1;
      this.getData(); 
    },
    handleSwitch(val) {
      this.switchCh = val;
    },


    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },
    getData() {
      if (this.search.trx_datetime.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Transaction date is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('report/inputerAggregatorTransaction/clearData');
      } else {
        const source = this.checkEnvCh;

        this.$store.commit(
          'report/inputerAggregatorTransaction/setFlashErrorMessage',
          ''
        );
        const { page, itemsPerPage } = this.options;
        this.$store
          .dispatch('report/inputerAggregatorTransaction/getData', {
            date,
            page,
            itemsPerPage,
            sortBy: ['trx_datetime'],
            sortDesc: [true],
            search: this.search,
            source,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage === 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    closeFlash() {
      this.$store.commit(
        'report/inputerAggregatorTransaction/setFlashErrorMessage',
        ''
      );
    },

    clearSearch() {
      const fields = ['trx_datetime', 'ac_id', 'payment_type', 'rrn', 'mid', 'status', 'bill_num', 'promo_code', 'qr_method'];
      fields.forEach(field => {
        const value = field === 'trx_datetime' ? [] : '';
        this.$set(this.search, field, value);
        this.$set(this.filterValue, field, value);
      });

      this.submittedFilter = JSON.parse(JSON.stringify(this.filterValue));
      
      this.$nextTick(() => {
        this.$store.commit('report/inputerAggregatorTransaction/clearData');
        this.$store.commit('report/clearAggregator');
        this.$store.commit('report/clearMerchant');
      });
    },

    async viewItem(itemId) {
      await this.$store
        .dispatch('report/inputerAggregatorTransaction/getDetail', {
          id: itemId,
          date,
        })
        .then(() => {
          if (!this.loading && this.detailData != null) {
            this.editedIndex = itemId;
          }
          this.editedItem = { ...this.detailData };
          this.view = true;
          this.editedIndex = -2;
          this.dialog = true;
        });
    },
    close() {
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    exportExcel() {
      if (this.totalData < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('report/inputerAggregatorTransaction/clearData');
      } else {
        const { page, itemsPerPage } = this.options;

        this.$store.dispatch('exportExcel', {
          date,
          page,
          itemsPerPage,
          sortBy: ['trx_datetime'],
          sortDesc: [true],
          search: this.submittedFilter,
          countData: this.totalData,
          module: 'aggregator-trx-inputer',
          exportUrl: 'export/generate-export-file/index',
          exportController: 'export/get-export-file',
          sourceData: this.checkEnvCh,
        });
      }
    },
    exportItem() {
      if (this.totalData < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('report/inputerAggregatorTransaction/clearData');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store.dispatch('exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          exportUrl: 'api/v1/export/export-inputer-transaction/aggregator',
          exportController: 'export-inputer-transaction',
        });
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};